import React from "react";
import "./WarningView.css";
import RollerLoadingAnimation from "./components/Settings/Storage/StorageCalibration/AutoCalibration/RollerLoadingAnimation";

type Props = {
  title: string;
  message: string;
  instruction?: string;
  onClickOk?: () => void;
  onClickCancel?: () => void;
};

export default function WarningWaitView({ title, message }: Props) {
  return (
    <div className="app-warning-wait-container">
      <span className="warning-title-wait">{title}</span>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gridArea: "animation",
          marginBottom: 40,
          marginTop: 41,
        }}
      >
        <RollerLoadingAnimation />
      </div>
      <span className="warning-message-wait centered">{message}</span>
      <span className="warning-sub-message-wait centered">{"This process cannot be terminated. Please wait for a few moments."}</span>
    </div>
  );
}
